var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePlayStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 29,
    viewBox: "0 0 96 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.352754,
    y: 0.352754,
    width: 94.538,
    height: 27.5148,
    rx: 3.88029,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.352754,
    y: 0.352754,
    width: 94.538,
    height: 27.5148,
    rx: 3.88029,
    stroke: "#A6A6A6",
    strokeWidth: 0.705507
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.0701 15.3461C46.4107 15.3461 45.0583 16.6082 45.0583 18.3466C45.0583 20.0744 46.4107 21.3471 48.0701 21.3471C49.7302 21.3471 51.0826 20.0744 51.0826 18.3466C51.0819 16.6082 49.7295 15.3461 48.0701 15.3461ZM48.0701 20.1661C47.1607 20.1661 46.3769 19.4161 46.3769 18.3473C46.3769 17.2671 47.1614 16.5285 48.0701 16.5285C48.9795 16.5285 49.7633 17.2671 49.7633 18.3473C49.7633 19.4154 48.9795 20.1661 48.0701 20.1661ZM41.499 15.3461C39.8396 15.3461 38.4872 16.6082 38.4872 18.3466C38.4872 20.0744 39.8396 21.3471 41.499 21.3471C43.1591 21.3471 44.5115 20.0744 44.5115 18.3466C44.5115 16.6082 43.1591 15.3461 41.499 15.3461ZM41.499 20.1661C40.5896 20.1661 39.8058 19.4161 39.8058 18.3473C39.8058 17.2671 40.5903 16.5285 41.499 16.5285C42.4084 16.5285 43.1922 17.2671 43.1922 18.3473C43.1929 19.4154 42.4084 20.1661 41.499 20.1661ZM33.6834 16.2674V17.5402H36.7298C36.6388 18.2563 36.4003 18.779 36.0363 19.1424C35.5932 19.5854 34.8997 20.0744 33.6834 20.0744C31.8081 20.0744 30.3421 18.5625 30.3421 16.6872C30.3421 14.812 31.8081 13.3001 33.6834 13.3001C34.6951 13.3001 35.4338 13.698 35.9791 14.2095L36.8772 13.3114C36.1153 12.584 35.1043 12.0273 33.6834 12.0273C31.1146 12.0273 28.9551 14.1185 28.9551 16.6872C28.9551 19.256 31.1146 21.3471 33.6834 21.3471C35.0697 21.3471 36.116 20.892 36.9337 20.0398C37.7746 19.1988 38.0364 18.0164 38.0364 17.0618C38.0364 16.7669 38.0138 16.4939 37.9679 16.2667H33.6834V16.2674ZM65.6485 17.2559C65.3988 16.5856 64.6368 15.3461 63.0798 15.3461C61.534 15.3461 60.2493 16.5623 60.2493 18.3466C60.2493 20.0285 61.5227 21.3471 63.2272 21.3471C64.6023 21.3471 65.3981 20.5061 65.7282 20.0172L64.7053 19.335C64.3645 19.8352 63.8982 20.1647 63.2272 20.1647C62.557 20.1647 62.0794 19.8578 61.7725 19.2553L65.7847 17.5959L65.6485 17.2559ZM61.5566 18.2563C61.5227 17.0964 62.4547 16.5059 63.1256 16.5059C63.6484 16.5059 64.0915 16.7676 64.2396 17.1423L61.5566 18.2563ZM58.295 21.1658H59.6129V12.3462H58.295V21.1658ZM56.1348 16.017H56.0896C55.794 15.6642 55.2254 15.3461 54.51 15.3461C53.0094 15.3461 51.6343 16.6646 51.6343 18.3586C51.6343 20.0405 53.0094 21.3478 54.51 21.3478C55.2261 21.3478 55.794 21.0296 56.0896 20.6663H56.1348V21.0981C56.1348 22.2459 55.521 22.8597 54.5325 22.8597C53.7254 22.8597 53.2252 22.2805 53.0206 21.7916L51.8728 22.2692C52.2023 23.0643 53.0771 24.0421 54.5325 24.0421C56.0783 24.0421 57.3856 23.1327 57.3856 20.916V15.5288H56.1355V16.017H56.1348ZM54.6236 20.1661C53.7142 20.1661 52.9529 19.4041 52.9529 18.3586C52.9529 17.301 53.7142 16.5285 54.6236 16.5285C55.521 16.5285 56.2258 17.301 56.2258 18.3586C56.2258 19.4041 55.521 20.1661 54.6236 20.1661ZM71.8245 12.3462H68.6702V21.1658H69.986V17.8245H71.8238C73.2828 17.8245 74.7178 16.7684 74.7178 15.0857C74.7178 13.4031 73.2835 12.3462 71.8245 12.3462ZM71.8584 16.5969H69.986V13.5738H71.8584C72.8426 13.5738 73.4013 14.3887 73.4013 15.0857C73.4013 15.7686 72.8426 16.5969 71.8584 16.5969ZM79.9943 15.3305C79.0412 15.3305 78.0542 15.7503 77.6457 16.6809L78.814 17.1684C79.0637 16.6809 79.5294 16.5214 80.0169 16.5214C80.6977 16.5214 81.3898 16.9299 81.4011 17.6559V17.7469C81.1626 17.6107 80.6518 17.4068 80.0282 17.4068C78.7688 17.4068 77.4862 18.0989 77.4862 19.3921C77.4862 20.5724 78.5191 21.3323 79.6761 21.3323C80.5608 21.3323 81.049 20.9351 81.3552 20.4694H81.4004V21.1503H82.6717V17.7688C82.6724 16.2039 81.5027 15.3305 79.9943 15.3305ZM79.8349 20.164C79.4045 20.164 78.8027 19.9481 78.8027 19.4147C78.8027 18.7339 79.552 18.4729 80.1989 18.4729C80.7767 18.4729 81.0497 18.5977 81.4011 18.7678C81.2988 19.5854 80.5954 20.164 79.8349 20.164ZM87.3012 15.5231L85.7922 19.347H85.747L84.1808 15.5231H82.7627L85.1114 20.8674L83.7723 23.8404H85.1452L88.7652 15.5231H87.3012ZM75.4445 21.1658H76.7603V12.3462H75.4445V21.1658Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4534 7.22692C33.4534 7.81814 33.2785 8.28871 32.9278 8.64005C32.5299 9.05771 32.0107 9.26654 31.3729 9.26654C30.7619 9.26654 30.242 9.05489 29.8151 8.63159C29.3876 8.20758 29.1738 7.68268 29.1738 7.05619C29.1738 6.42899 29.3876 5.90409 29.8151 5.48079C30.242 5.05678 30.7619 4.84513 31.3729 4.84513C31.6763 4.84513 31.9662 4.90439 32.2414 5.02221C32.5172 5.14074 32.7381 5.29806 32.9031 5.4949L32.5313 5.86741C32.2513 5.53229 31.8653 5.36509 31.3722 5.36509C30.9263 5.36509 30.5411 5.52171 30.2159 5.83496C29.8906 6.1482 29.7284 6.55528 29.7284 7.05548C29.7284 7.55569 29.8906 7.96276 30.2159 8.27601C30.5411 8.58926 30.9263 8.74588 31.3722 8.74588C31.8449 8.74588 32.2393 8.58855 32.5546 8.27319C32.7592 8.06789 32.8777 7.78216 32.9095 7.416H31.3722V6.90733H33.4231C33.4443 7.01809 33.4534 7.12462 33.4534 7.22692Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7059 5.45896H34.7784V6.80083H36.5168V7.30951H34.7784V8.65138H36.7059V9.17204H34.2345V4.939H36.7059V5.45896Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9994 9.17204H38.4555V5.45896H37.273V4.939H40.1818V5.45896H38.9994V9.17204Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2863 9.17204V4.939H42.8303V9.17204H42.2863Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2425 9.17204H44.6986V5.45896H43.5162V4.939H46.425V5.45896H45.2425V9.17204Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9313 8.62527C51.515 9.05281 50.9979 9.26658 50.3792 9.26658C49.7604 9.26658 49.2433 9.05281 48.8278 8.62527C48.4115 8.19773 48.2041 7.67425 48.2041 7.05552C48.2041 6.43679 48.4115 5.9133 48.8278 5.48576C49.2433 5.05822 49.7604 4.84375 50.3792 4.84375C50.9944 4.84375 51.5108 5.05893 51.9285 5.48858C52.3461 5.91824 52.555 6.44031 52.555 7.05552C52.555 7.67425 52.3468 8.19773 51.9313 8.62527ZM49.2292 8.2704C49.5424 8.58788 49.9255 8.74591 50.3792 8.74591C50.8328 8.74591 51.2166 8.58717 51.5292 8.2704C51.8424 7.95292 51.9997 7.54796 51.9997 7.05552C51.9997 6.56307 51.8424 6.15811 51.5292 5.84063C51.2166 5.52315 50.8328 5.36512 50.3792 5.36512C49.9255 5.36512 49.5424 5.52386 49.2292 5.84063C48.9167 6.15811 48.7593 6.56307 48.7593 7.05552C48.7593 7.54796 48.9167 7.95292 49.2292 8.2704Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3183 9.17204V4.939H53.9801L56.0374 8.2316H56.0606L56.0374 7.41604V4.939H56.5813V9.17204H56.0134L53.8609 5.71929H53.8376L53.8609 6.53486V9.17204H53.3183Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4534 7.22692C33.4534 7.81814 33.2785 8.28871 32.9278 8.64005C32.5299 9.05771 32.0107 9.26654 31.3729 9.26654C30.7619 9.26654 30.242 9.05489 29.8151 8.63159C29.3876 8.20758 29.1738 7.68268 29.1738 7.05619C29.1738 6.42899 29.3876 5.90409 29.8151 5.48079C30.242 5.05678 30.7619 4.84513 31.3729 4.84513C31.6763 4.84513 31.9662 4.90439 32.2414 5.02221C32.5172 5.14074 32.7381 5.29806 32.9031 5.4949L32.5313 5.86741C32.2513 5.53229 31.8653 5.36509 31.3722 5.36509C30.9263 5.36509 30.5411 5.52171 30.2159 5.83496C29.8906 6.1482 29.7284 6.55528 29.7284 7.05548C29.7284 7.55569 29.8906 7.96276 30.2159 8.27601C30.5411 8.58926 30.9263 8.74588 31.3722 8.74588C31.8449 8.74588 32.2393 8.58855 32.5546 8.27319C32.7592 8.06789 32.8777 7.78216 32.9095 7.416H31.3722V6.90733H33.4231C33.4443 7.01809 33.4534 7.12462 33.4534 7.22692Z",
    stroke: "white",
    strokeWidth: 0.141101,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7059 5.45896H34.7784V6.80083H36.5168V7.30951H34.7784V8.65138H36.7059V9.17204H34.2345V4.939H36.7059V5.45896Z",
    stroke: "white",
    strokeWidth: 0.141101,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9994 9.17204H38.4555V5.45896H37.273V4.939H40.1818V5.45896H38.9994V9.17204Z",
    stroke: "white",
    strokeWidth: 0.141101,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2863 9.17204V4.939H42.8303V9.17204H42.2863Z",
    stroke: "white",
    strokeWidth: 0.141101,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2425 9.17204H44.6986V5.45896H43.5162V4.939H46.425V5.45896H45.2425V9.17204Z",
    stroke: "white",
    strokeWidth: 0.141101,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9313 8.62527C51.515 9.05281 50.9979 9.26658 50.3792 9.26658C49.7604 9.26658 49.2433 9.05281 48.8278 8.62527C48.4115 8.19773 48.2041 7.67425 48.2041 7.05552C48.2041 6.43679 48.4115 5.9133 48.8278 5.48576C49.2433 5.05822 49.7604 4.84375 50.3792 4.84375C50.9944 4.84375 51.5108 5.05893 51.9285 5.48858C52.3461 5.91824 52.555 6.44031 52.555 7.05552C52.555 7.67425 52.3468 8.19773 51.9313 8.62527ZM49.2292 8.2704C49.5424 8.58788 49.9255 8.74591 50.3792 8.74591C50.8328 8.74591 51.2166 8.58717 51.5292 8.2704C51.8424 7.95292 51.9997 7.54796 51.9997 7.05552C51.9997 6.56307 51.8424 6.15811 51.5292 5.84063C51.2166 5.52315 50.8328 5.36512 50.3792 5.36512C49.9255 5.36512 49.5424 5.52386 49.2292 5.84063C48.9167 6.15811 48.7593 6.56307 48.7593 7.05552C48.7593 7.54796 48.9167 7.95292 49.2292 8.2704Z",
    stroke: "white",
    strokeWidth: 0.141101,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3183 9.17204V4.939H53.9801L56.0374 8.2316H56.0606L56.0374 7.41604V4.939H56.5813V9.17204H56.0134L53.8609 5.71929H53.8376L53.8609 6.53486V9.17204H53.3183Z",
    stroke: "white",
    strokeWidth: 0.141101,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_2858_42145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.36278 5.3181C7.15748 5.5354 7.03613 5.87263 7.03613 6.30934V21.9123C7.03613 22.3498 7.15748 22.6863 7.36278 22.9036L7.41499 22.9544L16.1555 14.2138V14.1108V14.0078L7.41499 5.2666L7.36278 5.3181Z",
    fill: "url(#paint0_linear_2858_42145)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0683 17.128L16.1553 14.2135V14.1105V14.0075L19.069 11.0938L19.1346 11.1311L22.5867 13.0925C23.5723 13.6526 23.5723 14.5691 22.5867 15.13L19.1346 17.0913L19.0683 17.128Z",
    fill: "url(#paint1_linear_2858_42145)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_2858_42145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1344 17.0914L16.1543 14.1113L7.36231 22.9041C7.68684 23.2484 8.22373 23.2907 8.82835 22.9478L19.1344 17.0914Z",
    fill: "url(#paint2_linear_2858_42145)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.1344 11.1309L8.82835 5.27519C8.22373 4.93161 7.68684 4.97464 7.36231 5.31893L16.155 14.1117L19.1344 11.1309Z",
    fill: "url(#paint3_linear_2858_42145)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_2858_42145",
    x: 7.03613,
    y: 5.03809,
    width: 16.29,
    height: 18.1465,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.105826
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2858_42145"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.105826
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2858_42145",
    result: "effect2_innerShadow_2858_42145"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_2858_42145",
    x: 7.3623,
    y: 14.1113,
    width: 11.7725,
    height: 9.07324,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.105826
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2858_42145"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2858_42145",
    x1: 15.3807,
    y1: 6.14425,
    x2: 3.54091,
    y2: 17.9841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2858_42145",
    x1: 23.8696,
    y1: 14.1105,
    x2: 6.79926,
    y2: 14.1105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2858_42145",
    x1: 17.516,
    y1: 15.7297,
    x2: 1.45975,
    y2: 31.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2858_42145",
    x1: 5.148,
    y1: 0.124845,
    x2: 12.3176,
    y2: 7.29442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayStore);
export default __webpack_public_path__ + "static/media/GooglePlayStore.ae7f4b28d4643f6fcbd691c788d14eeb.svg";
export { ForwardRef as ReactComponent };